export function initMosaicWrapper() {
    // Cerchiamo l'hook nel DOM
    if (document.querySelector('.js-mosaic-reveal')) {
        // Dynamic Import: Scarica il file pesante e Anime.js solo ora
        import('./mosaic_wrapper.js')
            .then(module => module.default())
            .catch(err => console.error("Errore caricamento Mosaic:", err));
    }
}
